import React from 'react';
import { Footer } from '../components/HomePage';
//import HowItWorksHeader from '../components/HowItWorks/HowItWorksHeader';
import PlanDetail from '../components/PlanDetail/PlanDetail';
import { Header } from '../components/HomePage';

function PlanDetailPage() {
  return (
    <>
      <Header />
      <PlanDetail />
      <Footer />
    </>
  );
}

export default PlanDetailPage;